import { render } from "./ProjectAllocation.vue?vue&type=template&id=4fb440ea&scoped=true"
import script from "./ProjectAllocation.vue?vue&type=script&lang=js"
export * from "./ProjectAllocation.vue?vue&type=script&lang=js"

import "./ProjectAllocation.vue?vue&type=style&index=0&id=4fb440ea&lang=scss&scoped=true"

import exportComponent from "/opt/lampp/htdocs/gslhrm/v6061/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fb440ea"]])

export default __exports__